import { PROCESS } from "@/data/business";

export default function Process() {
  return (
    <section className="bg-slate-50 py-20 lg:py-28 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-600">
            Simple Process
          </p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
            How It Works
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-8 relative">
          {PROCESS.map((p, i) => (
            <div key={p.step} className="relative" data-testid={`process-step-${p.step}`}>
              <div className="bg-white border border-slate-200 rounded-sm p-8 h-full hover:border-red-600 transition-colors">
                <span className="font-heading text-5xl font-black text-slate-100 group-hover:text-red-100">
                  {p.step}
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold text-slate-900">
                  {p.title}
                </h3>
                <p className="mt-2 text-slate-600 leading-relaxed">{p.desc}</p>
              </div>
              {i < PROCESS.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-px bg-red-400" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
